/**
 * Who is allowed to change what, by role (JBWEB-1213).
 *
 * The admin app is reached by two roles: 500, the admins themselves, and 515,
 * the collaborators working alongside them — AdminProfil names them "Admin"
 * and "Collaborateur". Both clear the `role >= 500` gate every admin endpoint
 * checks, so that gate says "may use the admin app", not "may change anything
 * in it".
 *
 * Settings that decide what a client is billed are the second kind, and 500
 * exactly is what separates them.
 */
export const SUPER_ADMIN_ROLE = 500;

export const isSuperAdmin = (userData) =>
  userData?.role === SUPER_ADMIN_ROLE;

const isAdminAppRole = (role) =>
  typeof role === 'number' && role >= 500 && role < 600;

/**
 * Generating a contract on BeSTT, updating it and sending it for signature:
 * role 500, or an admin-app user granted `canGenerateAndSignContracts` in the
 * database (no screen writes it). Twin of `canGenerateAndSignContracts` in
 * api/utils/roles.js, which is the actual guard.
 */
export const canGenerateAndSignContracts = (userData) =>
  isSuperAdmin(userData) ||
  (isAdminAppRole(userData?.role) &&
    userData?.canGenerateAndSignContracts === true);

export default isSuperAdmin;
